export function videoBg() {
  let videoBgContainer = document.getElementById("video-bg");
  if (!videoBgContainer) {
    return;
  }

  let video = document.createElement("video");
  video.classList.add("video-bg__video");
  video.loop = true;
  video.muted = true;
  video.autoplay = true;

  if (video.canPlayType("video/mp4").length > 0) {
    video.src = "./images/movie/video-tlo-compresed.mp4";
  }

  videoBgContainer.appendChild(video);
}
